import { emitters } from 'config';
import { MainContext } from 'context';
import { useContext } from 'react';
import { styled } from '../themes';

const Text = styled('p', {
  font: 'normal normal medium 12px/28px Montserrat',
  fontSize: 14,
  textAlign: 'left',
  letterSpacing: 0,
  opacity: 1,
  marginY: 0,
  color: '$copyRightColor',

  '@media (max-width: 768px)': {
    textAlign: 'center',
  },
});
function Copyright(): JSX.Element {
  const dataAtual = Number(new Date().getFullYear());
  const { state } = useContext(MainContext);
  return (
    <Text>
      {` © ${dataAtual} ${
        emitters[state.emissor].social
      } - Todos os direitos reservados`}
    </Text>
  );
}

export default Copyright;
